function validate(key, value, t) {
    
    switch (key) {
        case 'roomName':
            if(value?.length === 0){
                return {
                    value: true,
                    helperText: 'validate.room-name'
                }
            }
            if(value?.length > 100){
                return {
                    value: true,
                    helperText: 'validate.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'description':
            if(value?.length > 500){
                return {
                    value: true,
                    helperText: 'validate.description'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'password':
            if(value?.length === 0){
                return {
                    value: true,
                    helperText: 'validate.pwdRoomRequired'
                }
            }
            if(value?.length < 8){
                return {
                    value: true,
                    helperText: 'room.validate.password-min'
                }
            }
            if(value?.length > 32){
                return {
                    value: true,
                    helperText: 'room.validate.password-max'
                }
            }
            if(!/^[A-Za-z0-9@$!%*?&]+$/.test(value)){
                return {
                    value: true,
                    helperText: 'room.validate.password-match'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        default:
            break;
    }
}

export const handleValidateInput = (data, t) => {
    const error = {
        roomName: {value: false, helperText: ''},
        description: {value: false, helperText: ''},
        timeStart: {value: false, helperText: ''},
        timeEnd: {value: false, helperText: ''},
        password: {value: false, helperText: ''},
        operatorList: {value: false, helperText: ''},
        participantList: {value: false, helperText: ''},
        setting: {value: false, helperText: ''}
    }

    Object.keys(error).forEach(key => error[key] = validate(key, data[key], t))
    return error
}